<style lang="scss" scoped>
.card-item-content {
  padding: 14px 16px;
}
</style>
<template>
  <div>
    <div class="main-content">
      <loading :active.sync="isLoading" :is-full-page="false"></loading>
      <div class="content-wrapper">
        <div class="card-item">
          <div class="card-item-content small-padding px-3">
            <v-row no-gutters align="center">
              <v-col cols="7">
                <input-text
                  v-model="paging.name"
                  @input="search"
                  :placeholder="$t('_LIST_USER.SEARCH_PLACEHOLDER')"
                  class="main-input-text"
                />
              </v-col>
              <v-col cols="5" class="text-right">
                <button @click="addUser" class="main-btn btn-pmirary">{{$t('ADD_NEW')}}</button>
              </v-col>
            </v-row>
          </div>
          <v-data-table
            :headers="headers"
            :items="data"
            :items-per-page="15"
            disable-sort
            hide-default-footer
            item-key="username"
            class="main-table"
          >
            <!-- Row items -->
            <template slot="no-data">
              <span>{{$t("HAS_NO_DATA")}}</span>
            </template>
            <template v-slot:item.userGroup="{ item }">
              <div>
                <span style="font-weight: 500;">{{item.userGroup}}</span>
              </div>
            </template>
            <template v-slot:item.userName="{ item }">
              <div>
                <span>{{item.userName}}</span>
              </div>
            </template>
            <template v-slot:item.fullName="{ item }">
              <div>
                <span>{{item.fullName}}</span>
              </div>
            </template>
            <template v-slot:item.email="{ item }">
              <div>
                <span>{{item.email}}</span>
              </div>
            </template>
            <template v-slot:item.createdBy="{ item }">
              <div>
                <span>{{item.createdBy}}</span>
              </div>
            </template>
            <template v-slot:item.createdDate="{ item }">
              <div>
                <span>{{formatDateTime(item.createdDate, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm')}}</span>
              </div>
            </template>
            <template v-slot:item.active="{ item }">
              <div>
                <span
                  v-if="!item.active"
                  class="status-deactived not-active"
                >{{$t('_LIST_USER.STATUS_DEACTIVATE')}}</span>
                <span
                  v-if="item.active"
                  class="status-actived active"
                >{{$t('_LIST_USER.STATUS_ACTIVATE')}}</span>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <div>
                <a @click="editUser(item)" class="btn-edit">{{$t('EDIT')}}</a>
                <span class="mx-1">|</span>
                <a @click="openDialogDeleteUser(item)" class="btn-delete">{{$t('DELETE')}}</a>
              </div>
            </template>
          </v-data-table>
          <paging v-if="paging && paging.total" :paging.sync="paging" @changePage="changePage">
            <span slot="totalItems">{{$t("TOTAL")}}: {{paging.total}} {{$t("_LIST_USER.USER")}}</span>
          </paging>
        </div>
      </div>
    </div>
    <!-- Delete user dialog -->
    <v-dialog v-model="deleteUserDialog" max-width="260" content-class="dialog-confirm">
      <v-card>
        <span v-if="isCurrentUser">{{ $t('_LIST_USER.CANNOT_DELETE_CURRENT_USER') }}</span>
        <span v-else>{{$t('_LIST_USER.REMOVE')}}</span>
        <v-row class="d-flex justify-center">
          <v-col cols="6" class="btn-left-wrapper">
            <button class="main-btn btn-secondary" @click="deleteUserDialog = false">{{$t('CLOSE')}}</button>
          </v-col>
          <v-col cols="6" class="btn-right-wrapper" v-if="!isCurrentUser">
            <button class="main-btn btn-danger" @click="deleteUser">{{$t('DELETE')}}</button>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Input from "@/components/Utils/Input.vue";
import Paging from "@/components/Utils/Paging.vue";
import { LIMIT_AND_OFFSET } from "@/_helpers/config.js";
import { _alert, _formatDateTime } from "@/_helpers/function.js";
import { service } from "@/_services/Account/ManageUser/manage-user.service.js";
import debounce from "lodash.debounce";
import { authenticationService } from "@/_services";

export default {
  components: {
    "input-text": Input,
    paging: Paging
  },
  data() {
    return {
      currentUsername:
        authenticationService.currentUserValue.user.username || {},
      isCurrentUser: false,
      isLoading: false,
      headers: [
        {
          text: this.$t("_LIST_USER.GROUP_NAME"),
          align: "left",
          value: "userGroup"
        },
        {
          text: this.$t("_LIST_USER.USERNAME"),
          align: "left",
          value: "userName"
        },
        {
          text: this.$t("_LIST_USER.NAME"),
          align: "left",
          value: "fullName"
        },
        {
          text: this.$t("_LIST_USER.EMAIL"),
          align: "left",
          value: "email"
        },
        {
          text: this.$t("_LIST_USER.CREATE_USER"),
          align: "left",
          value: "createdBy",
          width: "10%"
        },
        {
          text: this.$t("_LIST_USER.CREATE_DATE"),
          align: "left",
          value: "createdDate",
          width: "15%"
        },
        {
          text: this.$t("_LIST_USER.STATUS"),
          align: "left",
          value: "active",
          width: "15%"
        },
        {
          text: this.$t("_LIST_USER.ACTION"),
          align: "center",
          value: "action",
          width: "10%"
        }
      ],
      data: [],
      paging: {
        // total: 0,
        limit: 15,
        offset: 0,
        name: ""
      },
      currentUser: null,
      deleteUserDialog: false
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    search: debounce(function(value) {
      this.getAll();
    }, 300),
    formatDateTime(value, inputFormat, outputFormat) {
      return _formatDateTime(value, inputFormat, outputFormat);
    },
    // Run when start
    initialize() {
      // Call service
      this.getAll();
    },
    // Change page
    changePage(paging) {
      this.paging = paging;
      this.getAll();
    },
    // Get all user
    getAll() {
      this.isLoading = true;
      const body = {
         limit: this.paging.limit,
        offset: this.paging.offset,
        name: this.paging.name
      };
      service
        .getAllUser(body)
        .then(res => {
          if (res.responseCode === 0) {
            this.paging.total = res.total;
            this.data = res.data;
          }
        })
        .finally(() => (this.isLoading = false));
    },
    addUser() {
      this.$router.push({ name: "addUser" });
    },
    editUser(item) {
      this.$router.push({ name: "editUser", params: { id: item.userName } });
    },
    openDialogDeleteUser(item) {
      if (item.userName == this.currentUsername) {
        this.isCurrentUser = true;
      } else {
        this.isCurrentUser = false;
      }
      this.deleteUserDialog = true;
      this.currentUser = item;
    },
    deleteUser() {
      this.deleteUserDialog = false;
      if (!this.currentUser) {
        return;
      }
      this.isLoading = true;
      service
        .deleteUser(this.currentUser.userName)
        .then(res => {
          if (res.responseCode === 0) {
            this.initialize();
          }
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>